/**
 * Global DOM event used to open the AI chat drawer from anywhere in the app
 * (e.g. the mobile sticky bar) without prop-drilling or a context provider.
 */
export const OPEN_CHAT_EVENT = "bagnoman:open-chat";

export function openAiChat() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(OPEN_CHAT_EVENT));
  }
}
